import { render, staticRenderFns } from "./DashboardShipperFinance.vue?vue&type=template&id=36b365c0"
import script from "./DashboardShipperFinance.vue?vue&type=script&lang=js"
export * from "./DashboardShipperFinance.vue?vue&type=script&lang=js"
import style0 from "./DashboardShipperFinance.vue?vue&type=style&index=0&id=36b365c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports